/** Canonical SVG artwork. Vite resolves these URLs for each application's base. */
export const brandAssets = {
  logo: new URL("../public/brand/logo.svg?v=teal-book-1", import.meta.url).href,
  logoReversed: new URL("../public/brand/logo-reversed.svg?v=teal-book-1", import.meta.url).href,
  logoMonochrome: new URL("../public/brand/logo-monochrome.svg?v=teal-book-1", import.meta.url).href,
  mark: new URL("../public/brand/mark.svg?v=teal-book-1", import.meta.url).href,
  markReversed: new URL("../public/brand/mark-reversed.svg?v=teal-book-1", import.meta.url).href,
  markWhite: new URL('../public/brand/mark-white.svg?v=white-1', import.meta.url).href,
  markMonochrome: new URL("../public/brand/mark-monochrome.svg?v=teal-book-1", import.meta.url).href
} as const;
